import moment from 'moment'
import React from 'react'
import { Icon, Image } from 'semantic-ui-react'
import alerts from '../../../assets/svg/notification_alerts.svg'
import assignments from '../../../assets/svg/notification_assignments.svg'
import due_date from '../../../assets/svg/notification_due_date.svg'
import { IUserDetail } from '../../../types/user'
import { INotificationData } from '../types/notification'


interface StateProps {
  user: IUserDetail | null,
  notifications: INotificationData[]
  type: 'inbox' | 'archive'
}

interface DispatchProps {
  updateNotification: (employee_id: number, notification_ids: number[]) => Promise<number[]>
  deleteNotification: (notification: INotificationData) => void
}

type Props = StateProps & DispatchProps

const NotificationsSidebarItem = (props: Props): JSX.Element => {
  const { notifications, type, user, updateNotification, deleteNotification } = props

  const handleOnClick = (notification: INotificationData) => {
    if(type === 'inbox') {
      updateNotification(user ? +user.id : -1, [notification.id])
    } else {
      deleteNotification(notification)
    }
  }

  const renderItems = () => {
    return notifications.map(d => {
      const _date_diff =  moment(d.created_at, 'YYYY-MM-DD').diff(moment(new Date(), 'DD-MM-YYYY'), 'days')
      const _date = _date_diff === 0 ? 'Today' : _date_diff === -1 ? 'Yesterday' : moment(d.created_at).format('DD.MM.YYYY')
      return (
        <div key={d.id} style={{ display: 'flex', width: '100%', border: '1px solid #BEC8C3', borderRadius: '8px', background: type === 'inbox' ? '#E2FBF4' : 'transparent', marginTop: '1rem', height: '100px' }}>
          <div style={{ width: '15%' }}>
            <Image
              src={d.type == 'Alerts' ? alerts : d.type == 'Assignments' ? assignments : due_date}
              style={{ marginTop: '30px', marginLeft: '15px' }}
            />
          </div>
          <div style={{ width: '80%', padding: '1.2rem 0' }}>
            <p style={{ fontSize: '1rem', fontWeight: 'bold', color: '#172533', margin: 0 }}>{d.title}</p>
            {d.content}
            <div style={{ display: 'flex', alignItems: 'baseline', marginTop: '.4rem' }}>
              <p style={{ fontSize: '12px', fontWeight: 'bold', margin: 0 }}>{d.project_name}</p>
              <span className='dot'></span>
              <p style={{ fontSize: '12px', margin: 0 }}>{_date}</p>
            </div>
          </div>
          <p style={{ width: '5%', textAlign: 'right' }}>
            <Icon
              name={type === 'inbox' ? 'check circle' : 'times circle'}
              style={{ color: type === 'inbox' ? '#08D6A1' : '#FA5953', marginTop: '40px', marginRight: '10px' }}
              size='large'
              onClick={() => handleOnClick(d)}
            />
          </p>
        </div>
      )
    })
  }

  return (
    <React.Fragment>
      {renderItems()}
    </React.Fragment>
  )
}

export default NotificationsSidebarItem
